import EastIcon from "@mui/icons-material/East";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadosContratoChoiceEnum,
  gridSizeMdLg12,
  hasAllPermissions,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  useCheckPermissions,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { useFetchContratos } from "@/shared/actions/erp";
import { GeneralTable } from "@/shared/components/ui";
import { SAVE_CLIENTE_CONTRATO_PERMISSIONS } from "@/shared/constants/form-permissions";
import {
  AlertSeverityEnum,
  Contrato,
  EstadosActualizacionContratoEnum,
} from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useNavigate } from "react-router-dom";
import { useColumnsClientes } from "../../../shared/hooks";

export type ClientesFibraAprobadosProps = {
  tipoServicio?: string;
};

type FormDataClientes = {
  contratoState: EstadosContratoChoiceEnum;
  estadoInformacionContrato: EstadosActualizacionContratoEnum;
};
const ClientesFibraAprobados: React.FC<ClientesFibraAprobadosProps> = ({
  tipoServicio = "FIBRA",
}) => {
  useCheckPermissions(PermissionsEnum.api_view_contrato);
  const navigate = useNavigate();
  const setAlert = useUiStore((s) => s.setAlert);
  const clientesFibraOpticaReturnUrl = ROUTER_PATHS.clientes.fibraOpticaNav;

  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pagination, searchTerm, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* form ---------------------------
  const form = useForm<FormDataClientes>({
    defaultValues: {
      contratoState: EstadosContratoChoiceEnum.ALL,
      estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    },
  });

  const watchedContratoState = form.watch("contratoState");

  ///* fetch data ---------------------------
  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    enabled: !!watchedContratoState,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      tipo_servicio: tipoServicio,
      preventa_estado_aceptacion: true,
      estado_actualizacion: "REVISADO",
      ...filterObject,
    },
  });

  const onEdit = (original: Contrato) => {
    navigate(`${clientesFibraOpticaReturnUrl}/ver/${original.id_contrato}`);
  };

  ///* columns ---------------------------
  const { clientesFibraColumns } = useColumnsClientes();

  ///* effects ---------------------------
  useLoaders(isLoadingContratos || isRefetchingContratos);

  return (
    <Grid item container {...gridSizeMdLg12}>
      <GeneralTable<Contrato>
        columns={clientesFibraColumns}
        data={contratosPagingRes?.data?.data || []}
        //
        isLoading={isLoadingContratos}
        isRefetching={isRefetchingContratos}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={contratosPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
        ])}
        enableEditing={hasAllPermissions([
          ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([...SAVE_CLIENTE_CONTRATO_PERMISSIONS])}
        // onEdit={onEdit}
        onCustomEdit={(r) =>
          r.estado_contrato == EstadosContratoChoiceEnum.CANCELADO ? (
            ""
          ) : (
            <Tooltip title={"Ir a detalle"} placement="top">
              <IconButton
                onClick={() => {
                  if (
                    !hasAllPermissions([
                      PermissionsEnum.api_change_contrato,
                      PermissionsEnum.api_add_contrato,
                    ])
                  )
                    return setAlert(
                      true,
                      "Acceso denegado. No cumples con los permisos necesarios: [403]",
                      AlertSeverityEnum.error
                    );

                  onEdit(r!);
                }}
              >
                <EastIcon />
              </IconButton>
            </Tooltip>
          )
        }
        toolTipTitleEditIcon="Ir a detalle"
        canDelete={false}
      />
    </Grid>
  );
};

export default ClientesFibraAprobados;
